import Constants from './Constants';


export default class ProsDOMUtil {
  static hide(selectorEl) {
    selectorEl.removeClass(Constants.CLASS_SELECTOR_CLASS).hide().closest('.row').hide();
  }

  static forceWindowResize() {
    if (typeof (Event) === 'function') {
      // modern browsers
      window.dispatchEvent(new Event('resize'));
    } else {
      // for IE and other old browsers
      // causes deprecation warning on modern browsers
      const evt = window.document.createEvent('UIEvents');
      evt.initUIEvent('resize', true, false, window, 0);
      window.dispatchEvent(evt);
    }
  }
}
